export const specialOffers = 'special-offers';